module.exports = __webpack_public_path__ + "static/media/look-out-window.9ed9b817.png";